import AnimalCrossing from './AnimalCrossing';

export default AnimalCrossing;
